import { Task } from '../models';
import { ModelResource } from './resource';

export class AutomatedTasks extends ModelResource<Task> {
  model = Task;

  resourcePath = 'v1/automated-tasks';
}
